// extracted by mini-css-extract-plugin
export default {"apply-now-brn-holder":"InvestmentOpportunityDoc_apply-now-brn-holder__1NPFN"};